import { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';

import theme from '../../../styles/theme';
import { useUserContext } from '../../../contexts/UserContext';
import { usePostContext } from '../../../contexts/PostContext';
import { Text, Spacer, IconButton } from '../../atoms';
import { AvatarName } from '../../molecules';

const AnswerItemContainer = styled(Spacer)`
  width: 100%;
  display: block;
  animation: fadeIn 1s ease-in-out;
  padding: 10px;
  box-sizing: border-box;
  @keyframes fadeIn {
    from {
      border-radius: ${theme.surface.borderRadius};
      background-color: ${theme.colors.secondary};
    }
    to {
      border-radius: ${theme.surface.borderRadius};

      background-color: none;
      opacity: 1;
    }
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const AlignRight = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: ${theme.spacing.xs};
`;

const AnswerItem = ({ comment, postId, ...props }) => {
  const {
    user: { id },
  } = useUserContext();
  const { handleDeleteComment } = usePostContext();

  const onDeleteComment = useCallback(async () => {
    await handleDeleteComment(comment._id);
  }, [comment._id, handleDeleteComment]);

  return (
    <AnswerItemContainer size={theme.spacing.xs} align="vertical" {...props}>
      <Header>
        <AvatarName
          username={comment.author.username}
          src={comment.author.src}
        />
      </Header>
      <Text color={theme.colors.fontBase}>{comment.comment}</Text>
      {comment.author._id === id ? (
        <AlignRight>
          <IconButton
            name="trash"
            onClick={onDeleteComment}
            size={theme.iconSizes.sm}
            color={theme.colors.gray600}
          />
        </AlignRight>
      ) : null}
    </AnswerItemContainer>
  );
};

AnswerItem.propTypes = {
  comment: PropTypes.object.isRequired,
  postId: PropTypes.string.isRequired,
};

export default AnswerItem;
